<template>
  <div class="px-8" v-if="modelValue">
    <div class="font-weight-medium text-uppercase my-4 mb-0">
      Disable url when count is zero
    </div>
    <v-switch
      v-model="modelValue.settings.disableWhenCountIsZero"
      :label="modelValue.settings.disableWhenCountIsZero ? 'On' : 'Off'"
      hide-details
      color="primary"
    ></v-switch>
  </div>
</template>

<script lang="ts" setup>
import { useSettingsStore } from '@/stores/settings'
import { onMounted, ref } from 'vue'

const props = defineProps<{
  selectedPlacement: string,
  make: string
  model: string
}>()

const settingsStore = useSettingsStore()
const modelValue = ref()

onMounted(() => {
  modelValue.value = settingsStore.placements.placements[
    props.selectedPlacement
  ]['filter'].find((item: any) => {
    return (
      item.make === props.make &&
      item.model === props.model
    )
  })
})
</script>
